import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { currentFlowTypeEnum } from '../../common/components/constants';
import EmployeeConsumptions from './EmployeeConsumptions';
import { getEmployeeConsumptionsInitiate } from '../../../actions/employee';

const mapStateToProps = state => {
  const employeeOrdersData = _get(state, 'employees.ordersData', []);
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    viewOnlyMode,
    employeeOrdersData,
    selectedWorkspace,
    fetchingOrders:
      _get(state, 'apiState.GET_EMPLOYEE_CONSUMPTIONS.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEE_CONSUMPTIONS.isIdle', false),
    fetchedOrders: _get(
      state,
      'apiState.GET_EMPLOYEE_CONSUMPTIONS.success',
      true,
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  getEmployeeConsumptions: payload =>
    dispatch(getEmployeeConsumptionsInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmployeeConsumptions);
